import environment from '../../../common/environment';
import { DocumentType } from '../../product-card/interfaces/product-card.interface';
import { ProductCardData } from '../../product-card/product-card-display';
import { generateProductCardMetadataIdentifiersText } from '../../product-card/utils/product-card-metadata.util';
import { html, nothing, TemplateResult } from 'lit';

/**
 * Gets the default product catalog template.
 *
 * @param products
 */
export const getProductListDefault = (products: ProductCardData[], pdfHeader: TemplateResult, displayComments?: boolean): TemplateResult => {
  return html`
    <div class="row">
      ${pdfHeader}
    </div>
    ${products?.length ?
      products.map((product, index, products) => {
        const isLast = index === products.length - 1;
        const identifier = product?.mhid ? product?.mhid : product?.isbn;
        const identifierType = product.documentType === DocumentType.programs
          ? { 'Program ID': product?.programId }
          : { 'MHID': product?.isbn, 'ISBN13': product?.isbn13 };

        return html`
          <div class="row py-4 ${!displayComments && !isLast ? 'border-bottom' : ''}">
            <div class="col col-5">
              <a id="product-title-${identifier}" href="${product.url}" class="fw-semibold">
                ${product.title}
              </a>
              <div>
                <span id="program-family-${identifier}" class="fs-small">
                  ${product.partsOf?.label ? `Part of ${product.partsOf.label} |` : ''}
                </span>
                ${product.gradeLevels
                  ? html`<span class="fw-semibold fs-small">Grades:</span> ${product.gradeLevels}`
                  : ''}
              </div>
            </div>
            <div class="col col-5 text-center">
              ${generateProductCardMetadataIdentifiersText(identifierType, true)}
            </div>
            <div class="col col-2">
              ${product.netPrice
                ? html`
                  <span class="d-flex justify-content-start fw-bold">
                    $${product.netPrice.toFixed(2)}
                  </span>`
                : ``}
            </div>
          </div>
          ${displayComments && product?.comments ? 
            html`
              <div class="row no-gutters ${!isLast ? 'border-bottom' : ''}">
                <div class="col-12">
                  <p><strong>Comments:</strong></p>
                  <p class="fst-italic">"${product?.comments}"- <strong>${product?.userName}</strong></p>
                </div>
              </div>
            ` :
            nothing  
          }
        `;
      }) :
        displayComments ?
          html`
            <h1 aria-label="Your list is empty!">Your list is empty!</h1>
            <p aria-label="Start adding items to revisit them and share with others.">
              Start adding items to revisit them and share with others.
            </p>
          ` :
          nothing
      }
  `;
}

/**
 * Gets the header including the theme CSS file.
 */
export function getIframeHeader(): TemplateResult {
  return html`
    <head>
      <link rel="stylesheet" type="text/css" href="${environment().themeUrl}"/>
      <style>
        @media print {
          @page {
            margin-top: 0;
          }

          body {
            margin-top: 4rem;
          }
        }
      </style>
    </head>`;
}
